<div class="contact-section">
    <div class="container">
        <div class="contact-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="contact-img">
                        <img src="assets/img/contact.webp" alt="contact image">
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="contact-text">
                        <div class="section-head">
                            <h2>We Love to <span> Hear from You</span></h2>
                            <p>Feel free and share with us. We will get you</p>
                        </div>

                        <div class="contact-form">
                            <form id="contactForm">
                                <div class="row">
                                    <div class="col-md-12 col-sm-6">
                                        <div class="form-group mb-3">
                                            <input type="text" name="name" id="name" class="form-control" placeholder="Your Name" required>
                                        </div>
                                    </div>

                                    <div class="col-md-12 col-sm-6">
                                        <div class="form-group mb-3">
                                            <input type="email" name="email" id="email" class="form-control" placeholder="Your Email" required>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12">
                                        <div class="form-group mb-3">
                                            <textarea name="message" class="form-control" id="message" cols="30" rows="5" placeholder="Your Message" required></textarea>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12">
                                        <button type="submit" class="default-btn page-btn">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="footer-widget">
                    <div class="logo">
                        <a routerLink="/">
                            <img src="assets/img/logo-footer.svg" class="logo" alt="logo">
                        </a>
                    </div>
                    <div class="email mt-2">
                        <form class="newsletter-form">
                            <input type="email" class="form-control" placeholder="Email" name="EMAIL">
                            <button class="default-btn electronics-btn" type="submit"><i class="icofont-location-arrow"></i></button>
                        </form>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="footer-widget pl-10">
                    <h3>OUR PRODUCTS</h3>
                    <ul>
                        <li *ngFor="let produit of produits">
                            <i class="icofont-simple-right"></i>
                            <a routerLink="products/{{produit.url}}">
                                {{produit.titre}}
                            </a>
                        </li>
                        <!-- <li>
                            <i class="icofont-simple-right"></i>
                            <a routerLink="products/stretch-fabrics">
                                Stretch fabrics
                            </a>
                        </li>
                        <li>
                            <i class="icofont-simple-right"></i>
                            <a routerLink="products/tarpaulin-fabrics">
                                Tarpaulin fabrics
                            </a>
                        </li>
                        <li>
                            <i class="icofont-simple-right"></i>
                            <a routerLink="products/the-decorative-fabrics-for-Caidales-tents">
                                The decorative fabrics for Caidales tents
                            </a>
                        </li>
                        <li>
                            <i class="icofont-simple-right"></i>
                            <a routerLink="products/tapes-for-mattresses">
                                Tapes for mattresses
                            </a>
                        </li>
                        <li>
                            <i class="icofont-simple-right"></i>
                            <a routerLink="products/the-different-technical-fabrics">
                                The different technical fabrics
                            </a>
                        </li> -->
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-6">
                <div class="footer-widget pl-20">
                    <h3>Quick Links</h3>

                    <ul>
                        <li><i class="icofont-simple-right"></i> <a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i> <a routerLink="/about">About</a></li>
                        <li><i class="icofont-simple-right"></i> <a routerLink="/products">Products</a></li>
                        <li><i class="icofont-simple-right"></i> <a routerLink="/news">News</a></li>
                        <li><i class="icofont-simple-right"></i> <a routerLink="/contact">Contact</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="footer-widget">
                    <h3>Find Us</h3>
                    <!-- <p class="find-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed.</p> -->

                    <ul class="find-us">
                        <li>
                            <i class="icofont-phone"></i>
                            <a href="tel:+212808608496">+212 8 08 60 84 96</a>
                        </li>
                        <li>
                            <i class="icofont-ui-message"></i>
                            <a href="mailto:contact@hikmatex.ma">contact@hikmatex.ma</a>
                        </li>
                        <li>
                            <i class="icofont-ui-message"></i>
                            <a href="mailto:export@hikmatex.ma">export@hikmatex.ma</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="bottom-footer">
        <div class="container">
            <div class="row  align-items-center">
                <div class="col-lg-6">
                    <!-- <div class="footer-social">
                        <ul>
                            <li><a href="#" target="_blank"><i class="icofont-facebook"></i></a></li>
                            <li><a href="#" target="_blank"><i class="icofont-twitter"></i></a></li>
                            <li><a href="#" target="_blank"><i class="icofont-linkedin"></i></a></li>
                            <li><a href="#" target="_blank"><i class="icofont-instagram"></i></a></li>
                        </ul>
                    </div> -->
                </div>

                <div class="col-lg-6">
                    <div class="copyright-text text-end">
                        <p>&copy;2022 All right reserved <a href="#">MKDEV</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>

<div class="top-btn">
    <i class="icofont-scroll-long-up"></i>
</div>
